module.exports = __webpack_public_path__ + "img/participants-icon-active.b24c86d0.svg";